import {
  useMfaEnrollResult,
  useScreen,
} from '@auth0/auth0-acul-react/mfa-enroll-result';

export const useMfaEnrollResultManager = () => {
  const screen = useScreen();
  const mfaEnrollResult = useMfaEnrollResult();

  return {
    mfaEnrollResult,
    screen,
  };
};
